import React, { useEffect, useState } from 'react';
import { VIDEO_CONFIG } from '../constants/video-config';
import './VideoPopup.css';

const VideoPopup = ({ isOpen, onClose, onVideoSeen }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isOpen) {
            // Add body scroll lock when popup is open
            document.body.style.overflow = 'hidden';
            
            // Set loading to false after a short delay to show the video
            const timer = setTimeout(() => {
                setIsLoading(false);
            }, 500);

            return () => {
                clearTimeout(timer);
                document.body.style.overflow = 'unset';
            };
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isOpen]);

    const handleClose = () => {
        onVideoSeen();
        onClose();
    };

    const handleVideoEnd = () => {
        // Optional: Automatically close when video ends
        // Uncomment the line below if you want this behavior
        // handleClose();
    };

    if (!isOpen) return null;

    return (
        <div className="video-popup-overlay">
            <div className="video-popup-container">
                <div className="video-popup-header">
                    <h2>{VIDEO_CONFIG.TITLE}</h2>
                    <p>{VIDEO_CONFIG.DESCRIPTION}</p>
                    <button 
                        className="video-popup-close"
                        onClick={handleClose}
                        aria-label="Close video popup"
                    >
                        ×
                    </button>
                </div>
                
                <div className="video-popup-content">
                    {isLoading ? (
                        <div className="video-loading">
                            <div className="loading-spinner"></div>
                            <p>Loading video...</p>
                        </div>
                    ) : (
                        <iframe
                            src={VIDEO_CONFIG.LOOM_VIDEO_URL}
                            frameBorder="0"
                            webkitallowfullscreen
                            mozallowfullscreen
                            allowFullScreen
                            onLoad={() => setIsLoading(false)}
                            onEnded={handleVideoEnd}
                            title="Welcome Video"
                            className="video-iframe"
                        />
                    )}
                </div>
                
                <div className="video-popup-footer">
                    <button 
                        className="video-popup-skip"
                        onClick={handleClose}
                    >
                        Skip Video
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VideoPopup; 